import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import {
  getFreeTrialStatusError,
  getFreeTrialStatusSuccess,
  setFreeTrialStatusError,
  setFreeTrialStatusSuccess,
} from './actions'
import { GET_FREE_TRIAL_STATUS, SET_FREE_TRIAL_STATUS } from './constants'

const upgradeModalEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(GET_FREE_TRIAL_STATUS.INITIATE),
    mergeMap(() =>
      api.companies.getFreeTrialStatus(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map(({ isValidForTrial, message }) => getFreeTrialStatusSuccess(isValidForTrial, message)),
        catchError((error) => of(epicsErrorHandler(getFreeTrialStatusError, error)))
      )
    )
  )

const setFreeTrialEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SET_FREE_TRIAL_STATUS.INITIATE),
    mergeMap((action) =>
      api.companies
        .setFreeTrialStatus(state$.value.partnerOptions.selectedCompany?.value, {
          sendEmailOnly: action.payload.value,
        })
        .pipe(
          map(({ status, message }) => setFreeTrialStatusSuccess(status, message)),
          catchError((error) => of(epicsErrorHandler(setFreeTrialStatusError, error)))
        )
    )
  )

export default combineEpicsIsolated(upgradeModalEpic, setFreeTrialEpic)
